module.exports = __webpack_public_path__ + "static/slide-402ebbef24e9b0e179854042db545b1d.webp";